import React, { Component } from 'react'
import PropTypes from 'prop-types'

import SEO from './SEO'
import CustomSEO from './CustomSEO'
import Header from './Header'
import HeaderV3 from './HeaderV3'
import Footer from './Footer/index'
import FooterV3 from './Footer/FooterV3'
import FooterLegal from './Footer/FooterLegal'
import Disclosures from './Disclosures'

class Layout extends Component {
  componentDidMount() {
    if (window.heap) {
      window.heap.addUserProperties({ redesign: true })
    }
  }

  render() {
    const {
      children,
      dropInHeader,
      metaData,
      metaDataCustom,
      slug,
      footerLegalType,
      footerLegalData,
      disclosuresData,
      noNavigation,
      navigation,
      heros,
      odsLogin,
      noIndexNoFollow,
      noFooter,
      noHeader,
      noSEO,
      v3Styles,
      footerData,
      blogCategory,
      singlePage
    } = this.props
    let { hasFullLegal } = this.props
    const divClasses = ['layout']
    if (slug?.length) divClasses.push(slug)
    if (v3Styles) divClasses.unshift('v3')
    if (slug === '404') hasFullLegal = false

    let footer
    if (v3Styles) {
      footer = <FooterV3 data={footerData} />
    } else if (singlePage) {
      footer = (
        <div className="v3">
          <FooterV3 data={footerData} />
        </div>
      )
    } else {
      footer = <Footer />
    }

    return (
      <div className={divClasses.join(' ')}>
        {!noSEO && !metaDataCustom && <SEO metaData={metaData} noIndexNoFollow={noIndexNoFollow} />}
        {!noSEO && metaDataCustom && <CustomSEO metaDataCustom={metaDataCustom} />}
        {/* skip to main content
        <a href="#maincontent" className="hide-display">
          Skip to main content
        </a>
        {/* skip to main content
        <span className="impacted">
          We are experiencing longer than usual hold times as a result of our call centers being
          impacted by the coronavirus. We encourage you to leverage our self service options at our
          website, or for non-urgent inquiries please email us at{' '}
          <a href="mailto:support@avant.com">support@avant.com</a>. We apologize for the
          inconvenience and appreciate your patience.
        </span>
        */}
        {!noHeader &&
          (v3Styles ? (
            <HeaderV3
              dropInHeader={dropInHeader}
              heros={heros}
              odsLogin={odsLogin}
              navigation={navigation}
              blogCategory={blogCategory}
            />
          ) : (
            <Header
              dropInHeader={dropInHeader}
              heros={heros}
              noNavigation={noNavigation}
              odsLogin={odsLogin}
            />
          ))}
        {children}
        {!noFooter &&
          (hasFullLegal ? (
            <>
              {singlePage && disclosuresData && (
                <div className="v3">
                  <Disclosures data={disclosuresData} />
                </div>
              )}
              {!singlePage && disclosuresData && <Disclosures data={disclosuresData} />}
              {!disclosuresData && (
                <FooterLegal
                  type={footerLegalType}
                  data={footerLegalData}
                  disclosures={disclosuresData}
                  v3Styles={v3Styles}
                />
              )}
              {footer}
            </>
          ) : (
            footer
          ))}
        {/* media test */}
        {/* <div className="include-media-test" /> */}
      </div>
    )
  }
}

Layout.defaultProps = {
  footerLegalType: 'primary',
  footerLegalData: null,
  disclosuresData: null,
  metaData: 'generic',
  metaDataCustom: null,
  slug: null,
  hasFullLegal: false,
  heros: null,
  noNavigation: null,
  navigation: null,
  odsLogin: false,
  noIndexNoFollow: false,
  noFooter: false,
  noHeader: false,
  noSEO: false,
  v3Styles: '',
  footerData: null,
  blogCategory: ''
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  dropInHeader: PropTypes.object.isRequired,
  hasFullLegal: PropTypes.bool,
  metaData: PropTypes.string,
  metaDataCustom: PropTypes.object,
  slug: PropTypes.string,
  footerLegalType: PropTypes.string,
  footerLegalData: PropTypes.object,
  disclosuresData: PropTypes.object,
  heros: PropTypes.array,
  noNavigation: PropTypes.object,
  navigation: PropTypes.object,
  odsLogin: PropTypes.bool,
  noIndexNoFollow: PropTypes.bool,
  noFooter: PropTypes.bool,
  noHeader: PropTypes.bool,
  noSEO: PropTypes.bool,
  v3Styles: PropTypes.bool,
  footerData: PropTypes.object,
  blogCategory: PropTypes.string,
  singlePage: PropTypes.bool
}

Layout.defaultProps = {
  metaData: 'generic',
  singlePage: false
}

export default Layout
